import { useState } from 'react';
import { Box, Stack, Typography, createFilterOptions } from '@mui/material';
import { FormAutocomplete, IdentityAvatar } from '../../design-system';
import type { AbsenceResource, AbsenceWorker } from './model';

const filter = createFilterOptions<AbsenceWorker>({ stringify: (worker) => `${worker.name} ${worker.workerNumber} ${worker.jobTitle ?? ''} ${worker.organization?.descriptor ?? ''}` });

export function AbsenceWorkerPicker({ resource, value, onChange, disabled, label = '직원 검색', error, helperText, onBlur }: {
  resource: AbsenceResource<AbsenceWorker[]>; value: string; onChange: (id: string) => void; disabled?: boolean; label?: string;
  error?: boolean; helperText?: string; onBlur?: () => void;
}) {
  const [query, setQuery] = useState('');
  const selected = resource.data?.find((worker) => worker.id === value) ?? null;
  return <FormAutocomplete
    options={resource.data ?? []} value={selected} inputValue={selected?.name ?? query}
    disabled={disabled} filterOptions={filter} onBlur={onBlur}
    getOptionLabel={(worker) => worker.name} getOptionKey={(worker) => worker.id}
    isOptionEqualToValue={(option, selection) => option.id === selection.id}
    onInputChange={(_, input, reason) => { if (reason === 'input' || reason === 'clear') { setQuery(input); onChange(''); } }}
    onChange={(_, worker) => { setQuery(''); onChange(worker?.id ?? ''); }}
    request={resource.error ? { status: 'error', message: resource.error.message, onRetry: resource.reload } : resource.loading ? { status: 'loading' } : { status: 'ready' }}
    selectionError={value && !selected && !resource.loading && !resource.error ? '선택한 직원을 찾을 수 없습니다. 다시 검색해 주세요.' : undefined}
    renderOption={(props, worker) => {
      const { key, ...optionProps } = props;
      return <Box component="li" key={key} {...optionProps}><Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <IdentityAvatar size={32} src={worker.photoUrl} alt="">{Array.from(worker.name)[0]}</IdentityAvatar>
        <Stack><Typography variant="body2">{worker.name}</Typography><Typography variant="caption" color="text.secondary">{[worker.jobTitle, worker.organization?.descriptor].filter(Boolean).join(' · ') || '직무·조직 미등록'}</Typography></Stack>
      </Stack></Box>;
    }}
    noOptionsText="검색된 직원이 없습니다."
    input={{ label, required: true, placeholder: '이름, 직무 또는 조직으로 검색', error, helperText }}
  />;
}
